import { cn } from "@/lib/tailwind";
import Image from "next/image";
import { HeaderVariantWithBanner } from "./type";

const WithBanner = ({ containerClassName, imageProps }: HeaderVariantWithBanner) => {
  return (
    <div className={cn("h-full w-full", containerClassName)}>
      <Image {...imageProps} className="h-full w-full object-cover" />
    </div>
  );
};

export default WithBanner;
